





































































import { Vue, Component } from "vue-property-decorator";
import DocumentSvg from "@/components/svg/DocumentsSvg.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import { namespace } from "vuex-class";
import { NationalIdType } from "../types";
import axios from "axios";

const NationalId = namespace("nationalId");
const Document = namespace("document");

@Component({
  components: {
    "document-svg": DocumentSvg,
    "previous-page-arrow": PreviousPageArrow,
  },
})
export default class ChooseNationalId extends Vue {
  @NationalId.Action("setNationalIdType") setNationalIdType!: (
    nationalIdType: NationalIdType
  ) => void;
  @NationalId.Getter("getNationalIdType") getNationalIdType!: NationalIdType;
  @Document.Getter("getCountry") country!: string;
  isSelected = false;
  selectedNationalId = "";

  async mounted() {
    try {
      if (Vue.prototype.$useAudioInstructions) {
        Vue.prototype.$audioConfigs.stopEnterTrn?.();
        await Vue.prototype.$audioConfigs.playTypeOfNationalId?.();
      }
    } catch (err) {
      console.warn("Audio playback failed:", err);
    }
  }

  chooseNationalId() {
    // Regardless we go to capturing Front
    this.$router.push({
      name: "captureNationalFront",
      query: this.$route.query,
    });
  }
  setSelectedNationalId(event) {
    this.selectedNationalId = event.target.value;
    this.isSelected = true;
    switch (this.selectedNationalId) {
      case "nationalIdNew":
        this.chooseIdOldNew(15);
        this.setNationalIdType(NationalIdType.OLD);
        break;
      case "nationalIdOld":
        this.chooseIdOldNew(14);
        this.setNationalIdType(NationalIdType.OLD);
        break;
    }
  }

  chooseIdOldNew(progressionStep) {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }
}
